import { makeStyles } from '@material-ui/core';

const drawerWidth = 300;
export default makeStyles(theme => ({
  root: { display: 'flex' },

  content: {
    // flexGrow: 1,
    // padding: theme.spacing(3),
    // marginLeft: '20px',
    width: 'calc(100% - 225px)',
    [theme.breakpoints.up('sm')]: {
      // marginLeft:drawerWidth
    },
    // transition: 'margin-left 0.3s ease-out',

    '& div>#header': {
      right: 0,
      left: 335,
      transition: 'left 0.3s ease-out'
    }
    // '& div>div': {
    //   width:'100%'
    // }
  },


  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },

  sidebarCollapse: {
    width: 'calc(100% - 120px)',
    // margin:'0 auto',
    transition: 'width 0.3s ease-out',
    // overflowX: 'hidden',
    marginLeft: 20,

    '& div>#header': {
      right: 0,
      left: 120,
      transition: 'left 0.3s ease-out'
    }
    // '& ul>li>a>div>div': {
    //   display:'none',
    // },
    // '& ul>div>div':{
    //   display:'none'
    // },
    // '& ul>div>p':{
    //   display:'none'
    // },
    // '& a>div>div': {
    //   display:'none'
    // }
  },

  // toolbar: { minHeight: 70 },

  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%'
  }
}));
